/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Filter_Needs_ActionInputs */

const vi_einvoice_filter_needs_action = /** @type {(inputs: Einvoice_Filter_Needs_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chờ xuất hóa đơn`)
};

/**

* @param {Einvoice_Filter_Needs_ActionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_filter_needs_action = /** @type {((inputs?: Einvoice_Filter_Needs_ActionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Filter_Needs_ActionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_filter_needs_action(inputs)
});